// ===== EPG OPTIONS =====
export const EPG_WIDTH = 7200;
export const EPG_ITEM_WIDTH = 300;
export const EPG_ITEM_HEIGHT = 70;
